import React, { useEffect, useRef } from "react";
import { Message } from "ai/react";
import { ImproveChatMessage } from "./ImproveChatMessage";
import styles from "./ImproveChat.module.scss";
import { ChainOfThoughtStep } from "@/components/ai-elements/chain-of-thought-for-improve-chat";
import { Loader2 } from "lucide-react";
import { Text } from "@radix-ui/themes";
import improveChatLoader from "@/lottie/blood_cell_morph_loader.json";
import Lottie, {Options as LottieOptions} from "react-lottie";
const LottieDisplay = Lottie as any;

interface ImproveChatMessagesProps {
  messages: Message[];
  isLoading: boolean;
  isDisabled?: boolean;
}

export function ImproveChatMessages({
  messages,
  isLoading,
  isDisabled = false,
}: ImproveChatMessagesProps) {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <div className={styles.messagesContainer}>
      <div className={styles.messagesList}>
        {messages.map((message, index) => (
          <ImproveChatMessage
            key={message.id}
            message={message}
            isLast={index === messages.length - 1 && !isLoading}
            isDisabled={isDisabled}
          />
        ))}
        {isLoading && (
          <ChainOfThoughtStep
            icon={ <div className={styles.lottieWrapper}>
                <LottieDisplay
                    options={
                        {
                            loop: true,
                            autoplay: true,
                            animationData: improveChatLoader,
                        } as LottieOptions
                    }
                    height={26}
                    width={26}
                    isClickToPauseDisabled={true}
                />
            </div>}
            label=""
            status="active"
            style={{ width: "100%" }}
          >
            <Text className={styles.loadingText}>Processing your feedback...</Text>
          </ChainOfThoughtStep>
        )}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
}
